import { Dialog, TableRow } from '@material-ui/core';
import { Alert, Button, DialogActions, DialogContent, DialogContentText, DialogTitle, TableBody, TableCell, TableContainer, TableHead, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MissionTransportService from '../../../services/MissionTransportService';
import Message from '../../tools/Message';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import { useNavigate } from 'react-router';
import Table from '../../../components/Table';
import VehicleService from '../../../services/VehicleService';

const ConfirmationTransportByRow = (props) => {
    const { rowToConfirm, setRowToConfirm, closeDialog, setRows} = props;
    const navigate = useNavigate();
    const [missionId, setMissionId] = useState(0);
    const [loadingButton, setLoadingButton] = useState(false);
    const [confirmTransport, setConfirmTransport] = useState({ open: false,
                    mission_id: 0,
                    kilometersState: null,
                    reference: '',});
    const [drivers, setDrivers] = useState([]);
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [carpoolingDialog, setCarpoolingDialog] = useState({open: false, // s'il s'agit d'une co-voiturage
                    mission_id: 0,
                    kilometersState: null,
                    reference: '',});
    const [warnDialog, setWarnDialog] = useState(false);
     const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
      });
    const [carpooling, setCarpooling] = useState([]);
    const [alertDialog, setAlertDialog] = useState({
      open: false,
      message: ''
    });
      const { open, color, messageInfo } = message;
    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

     const handlePreviewConfirmTransport = async (row) => {
      if(row?.mission_planning_id) {
        setMissionId(row.mission_planning_id);
      }
     
      if (row?.vehicles?.length > 0) {
        setOpenLoadingSimpleBackdrop(true);
        for (const vehicle of row.vehicles) {
          console.log("vehicle", vehicle);
          try {
            const missionsByTransport = await MissionTransportService.missionsByTranport(vehicle.transport_id);
            if (missionsByTransport.status && Array.isArray(missionsByTransport.data)) {
              if (missionsByTransport.data.length === 1) {
                setConfirmTransport({
                  open: true,
                  mission_id: row.mission_planning_id,
                  kilometersState: row.mission_timesheet_state,
                  reference: row.reference,
                });
              } else {
                setCarpooling((prevCarpooling) => [
                  ...prevCarpooling.filter((item) => item.transport_id !== vehicle.transport_id),
                  {
                    vhc_id: vehicle.vhc_id,
                    vhc_imm: vehicle.vhc_imm,
                    captain_id: vehicle.captain_id,
                    vhc_type: vehicle.vhc_type,
                    transport_id: vehicle.transport_id,
                    driver_id: vehicle.driver_id,
                    missions: [],
                  },
                ]);

                for (const mission of missionsByTransport.data) {
                  
                setCarpooling((prevCarpooling) => {
                  const existingCarpooling = prevCarpooling.find(
                    (item) => item.transport_id === vehicle.transport_id
                  );
    
                  if (existingCarpooling) {
                    return prevCarpooling.map((item) =>
                      item.transport_id === vehicle.transport_id
                        ? { ...item, missions: [...item.missions, mission] }
                        : item
                    );
                  } else {
                    return [
                      ...prevCarpooling,
                      {
                        vhc_id: vehicle.vhc_id,
                        transport_id: vehicle.transport_id,
                        driver_id: vehicle.driver_id,
                        missions: [mission],
                      },
                    ];
                  }
              
                });
              }
                setCarpoolingDialog({
                  open: true,
                   mission_id: row.mission_planning_id,
                  kilometersState: row.mission_timesheet_state,
                  reference: row.reference,
                });
              }
    
              // Stop la boucle après le premier traitement (si nécessaire)
              break;
            }
    
          } catch (error) {
            console.error('Erreur lors de la récupération des missions par transport :', error);
            setMessage({
              open: true,
              color: 'red',
              messageInfo: "Échec de la récupération des missions par transport.",
            });
            break; // ou return;
          }
        }
        setOpenLoadingSimpleBackdrop(false);
      }
    };

    async function fetchDrivers() {
          setOpenLoadingSimpleBackdrop(true);
          try {
            const result = await VehicleService.getDriversMission();
            if (result?.data) {
              setDrivers(result.data);
            }
          } catch (error) {
            console.error("Error fetching drivers:", error);
          } finally {
            setOpenLoadingSimpleBackdrop(false);
          }
        }
    useEffect(() => {
        if (rowToConfirm) {
          console.log("rowToConfirm", rowToConfirm);
          if(rowToConfirm.state != 'Validé' || rowToConfirm.kilometrage_state !== 'CONFIRMED') {
            setAlertDialog({ open: true, message: rowToConfirm.state != 'Validé' ? "La mission n'est pas encore validée." : "Les kilométrages de la mission ne sont pas encore confirmés." });
            setRowToConfirm(null);
            return;
          }
            handlePreviewConfirmTransport(rowToConfirm); // verifier s'il s'agit d'une co-voiturage ou pas
            fetchDrivers(); // Récupérer les chauffeurs
        }
    }, [rowToConfirm]);
    
    const handleConfirmTransport = async () => {
        setLoadingButton(true);
        setOpenLoadingSimpleBackdrop(true); // Active le chargement
                try {
                  const missionId = confirmTransport.mission_id; 
                  const agendaId = rowToConfirm?.mission_planning_agenda_id || 0;
                  const timesheetId = rowToConfirm?.mission_kilometer_id || 0; // id de la feuille de temps associée à la mission
                  const kilometersState = confirmTransport.kilometersState; // Récupère l'état des kilométrages
            
                  if( kilometersState === 'PLANNING' || kilometersState === 'PENDING' || kilometersState === 'REFUSED') {
                    setWarnDialog({
                                open: true,
                                message: "La confirmation ne peut pas être effectuée car les kilométrages de la mission ne sont pas encore saisis ou ne pas encore valider."
                            });
                            return;
                  }
            
                  setConfirmTransport({
                    open: false,
                    mission_id: 0,
                    kilometersState: null,
                    reference: '',
                  })
                  setOpenLoadingSimpleBackdrop(true); // Active le chargement

               const [driverOM, result] = await Promise.all([
                    MissionTransportService.sendDriverOM(missionId, agendaId),
                    ProvisionalFuelMissionService.sendAndGenerateTimesheet(missionId, agendaId),
                    // MissionTransportService.confirmTransportMission(missionId, agendaId),
                  ]);
                  
                  if (result && driverOM) {
                    setMessage({
                      open: true,
                      color: 'green',
                      messageInfo: 'Gestion du transport confirmée.'
                    });
              
                    setRows((prevRows) =>
                      prevRows.map((row) =>
                        row.mission_planning_id === missionId ? { ...row, status: 'true' } : row
                      )
                    );
                  }
                } catch (error) {
                  console.error('Erreur lors de la confirmation du transport :', error);
                  setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: "Échec de la confirmation du transport."
                  });
                } finally {
                 closeDialog();
                 setRowToConfirm(null);
                 setOpenLoadingSimpleBackdrop(false); // Désactive le chargement
                 setLoadingButton(false); // Désactive le bouton de chargement
                }
              };
   const handleConfirmCarpooling = async () => {
      setOpenLoadingSimpleBackdrop(true);
      setLoadingButton(true);
      if (carpooling.length === 0) return;

      const missionsToConfirm = carpooling.map(item => item.missions).flat();
      const missionIds = missionsToConfirm.map(m => m.mission_planning_id);

      if (missionIds.length === 0) {
        setWarnDialog({ open: true, message: "Aucune mission à confirmer." });
        setOpenLoadingSimpleBackdrop(false);
        return;
      }

      // Générer le timesheet pour la première mission
      const timesheet = await ProvisionalFuelMissionService.sendAndGenerateTimesheet(missionIds[0]);
      if (!timesheet) {
        setAlertDialog({ open: true, message: "La confirmation du transport n'a pas pu être effectuée." });
        setOpenLoadingSimpleBackdrop(false);
        return;
      }

      try {
        for (const missionId of missionIds) {
          const confirmed = await MissionTransportService.confirmTransportMission(missionId);
          const omDriver = await MissionTransportService.sendDriverOM(missionId);

          if (!confirmed || !omDriver) {
            throw new Error(`Échec de la confirmation ou de l'envoi de l'OM pour la mission ${missionId}`);
          }
        }

        setRows(prevRows =>
          prevRows.map(row =>
            missionIds.includes(row.mission_planning_id)
              ? { ...row, status: 'true' }
              : row
          )
        );

        setMessage({
          open: true,
          color: 'green',
          messageInfo: 'Gestion du transport confirmée.'
        });

      } catch (error) {
        console.error('Erreur lors de la confirmation du transport :', error);
        setMessage({
          open: true,
          color: 'red',
          messageInfo: "Échec de la confirmation du transport."
        });
      } finally {
        setOpenLoadingSimpleBackdrop(false);
        setCarpoolingDialog({ open: false, mission_id: 0, kilometersState: null, reference: '' });
        setRowToConfirm(null);
        closeDialog();
        setLoadingButton(false);
      }
    };

    return (
        <>
              <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
              <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
                    <Dialog
                open={confirmTransport.open}
                onClose={() =>
                  setConfirmTransport({
                    open: false,
                    mission_id: 0,
                    kilometersState: null,
                    reference: '',
                  })
                }
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                  <Typography variant="h6" component="div">
                    Confirmation de la gestion du transport
                  </Typography>
                  {confirmTransport.reference && (
                    <Typography variant="subtitle2" style={{ color: "white" }}>
                      Mission {confirmTransport.reference}
                    </Typography>
                  )}
                </DialogTitle>
        
                <DialogContent dividers>
                  <DialogContentText id="alert-dialog-description">
                    La gestion du transport sera confirmée. <br />
                    L'Ordre de Mission (OM) du chauffeur sera envoyé. <br />
                    La prévision de carburant pour la mission sera automatiquement générée.
                  </DialogContentText>
                </DialogContent>
        
                <DialogActions>
                  <Button
                    onClick={() =>{
                      setConfirmTransport({
                        open: false,
                        mission_id: 0,
                        kilometersState: null,
                        reference: '',
                      })    
                      setRowToConfirm(null)
                      closeDialog();
                    }}
                     loading={loadingButton}
                    disabled={loadingButton}
                    loadingIndicator="Chargement..."
                     variant="contained"
                    color="error"
                  >
                    Annuler
                  </Button>
                  <Button
                    onClick={handleConfirmTransport}
                    disabled={loadingButton}
                    loading={loadingButton}
                    loadingIndicator="Chargement..."
                    variant="contained"
                    color="info"
                  >
                    Confirmer
                  </Button>
                </DialogActions>
              </Dialog>

              {/* s'il s'agit d'une co voiturage */}
              <Dialog
                open={carpoolingDialog.open}
                onClose={() => setCarpoolingDialog({ open: false, mission_id: 0, kilometersState: null, reference: '' })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" 
                fullWidth
                maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                       <Typography variant="h6" component="div">
                    Confirmation de la gestion du transport 
                  </Typography>
                  {carpoolingDialog.reference && (
                    <Typography variant="subtitle2" style={{ color: "white" }}>
                      Mission {carpoolingDialog.reference}
                    </Typography>
                  )}
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText id="alert-dialog-description">
                         <Alert severity="info" icon={false}>Ce transport est organisé en <b>co-voiturage</b>.</Alert>
                           <br />
                          La voiture est partagé entre plusieurs missions.
                          La gestion du transport pour chaque mission sera validée. <br />
                          L’Ordre de Mission (OM) du chauffeur sera transmis. Ainsi La prévision de carburant sera automatiquement générée. <br />
                          {/* Vous devrez gérer les kilométrages nécessaires afin d'estimer la consommation de la voiture. <br />
                          Merci de vérifier les informations ci-dessous avant de procéder à la confirmation. */}
                        </DialogContentText>

                        <Typography variant="subtitle2">
                           {/* <TableContainer sx={{ maxHeight: 440 }}> */}
        {/* <Table stickyHeader aria-label="sticky table">
          <TableHead>
            */}
                          <TableRow>
                              <TableCell><strong>Voiture</strong></TableCell>
                              <TableCell><strong>Chauffeur</strong></TableCell>
                              <TableCell><strong>Missions</strong></TableCell>
                          </TableRow>
                          {/* </TableHead> */}
                          <TableBody>
                          {carpooling.map((item) => (
                              <TableRow key={item.transport_id}>
                                  <TableCell>{item.vhc_imm + " - " + item.vhc_type} </TableCell> 
                                  <TableCell> {drivers.find(driver => driver.user_id == item.driver_id)?.name || 'Non attribué'} </TableCell>
                                  <TableCell>
                                    <TableRow>
                                      <TableCell>
                                        <strong>Reference</strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>Lieu</strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>Dates</strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>Missionnaires</strong>
                                      </TableCell>
                                      </TableRow>
                                    {item?.missions?.map(m => {
                                      return (
                                        <TableRow key={m.mission_planning_id}>
                                          <TableCell>{m.reference}</TableCell>
                                          <TableCell>{m.lieu}</TableCell>
                                          <TableCell>Du {formatDate(m.date_begin)} au {formatDate(m.date_end)}</TableCell>
                                          <TableCell>{m.users.map(user => {
                                            return (
                                              <span key={user.user_id}>{user.name} {user.user_id === item?.captain_id ? <span style={{ fontWeight: 'bold', color: '#00ccff' }}>(Chef de bord)</span> : ''}</span>
                                            );
                                          })}</TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableCell>
                              </TableRow>
                          ))}
                     </TableBody>
                     {/* </Table>
        </TableContainer > */}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {setCarpoolingDialog({ open: false, mission_id: 0, kilometersState: null, reference: '' }); closeDialog(); setRowToConfirm(null);}}
                            loading={loadingButton}
                            disabled={loadingButton}
                            loadingIndicator="Chargement..."
                            variant="contained"
                            color="error"
                        >
                            Annuler
                        </Button>
                        <Button
                            onClick={() => {
                              handleConfirmCarpooling();
                              // setCarpoolingDialog({ open: false, mission_id: 0, kilometersState: null, reference: '' });
                              // setRowToConfirm(null);
                              // closeDialog();
                            }}
                            disabled={loadingButton}
                            loading={loadingButton}
                            loadingIndicator="Chargement..."
                            variant="contained"
                            color="info"
                        >
                            CONFIRMER
                        </Button>
                        {/* <Button
                            onClick={() => {
                               navigate("/Logistic/mission/timesheet/" + missionId);
                            }}
                            variant="contained"
                            color="info"
                        >
                            GERER LA PREVISION CARBURANT
                        </Button> */}
                    </DialogActions>
                </Dialog>

                <Dialog
                open={warnDialog.open}
                onClose={() => setWarnDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                  <Typography variant="h6" component="div">
                    Attention
                  </Typography>
                </DialogTitle>
                <DialogContent dividers>
                  <DialogContentText id="alert-dialog-description">
                    {warnDialog.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                
                  <Button
                    onClick={() => {
                      setWarnDialog(false);
                      setRowToConfirm(null);
                      closeDialog();
                    }}
                    variant="contained"
                    color="info"
                  >
                    Fermer
                  </Button>
                </DialogActions>
                </Dialog>
            <Dialog
            open={alertDialog.open}
            onClose={() => setAlertDialog({ ...alertDialog, open: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
            >
                <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                  <Typography variant="h6" component="div">
                    Attention
                  </Typography>
                </DialogTitle>
                <DialogContent dividers>
                  <DialogContentText id="alert-dialog-description">
                    {alertDialog.message}  La confirmation du transport ne peut pas être effectuée.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setAlertDialog({
                        open: false,
                        message: ''
                      });
                      setRowToConfirm(null);
                      closeDialog();
                    }}
                    loading={loadingButton}
                    disabled={loadingButton}
                    loadingIndicator="Chargement..."
                    variant="contained"
                    color="error"
                  >
                    Fermer
                  </Button>
                </DialogActions>
            </Dialog>
              </>
    )

}
export default ConfirmationTransportByRow;
